import { getPermissions } from "@/helper/collection";
export const UserRoutes = {
  path: "/user-management",
  name: "User Management",
  redirect: "/user-management/users",
  component: {
    render(c) {
      return c("router-view");
    }
  },
  children: [
    {
      path: "/",
      name: "",
      component: () =>
        import("@/components/Pages/UserManagement/UsersManagementHome.vue"),
      meta: {}
    },
    {
      path: "users",
      name: "Users",
      component: () =>
        import("@/components/Pages/UserManagement/UsersComponents/users.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager", "ITManager"],
          false,
          "",
          1,
          1
        )
      }
    },
    {
      path: "aggregator-users",
      name: "Aggregator Users",
      component: () =>
        import(
          "@/components/Pages/UserManagement/UsersComponents/aggregatorUsers.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          2,
          1
        )
      }
    },
    {
      path: "add-user",
      name: "Add User",
      component: () =>
        import("@/components/Pages/UserManagement/UsersComponents/addUser.vue"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          1,
          2
        )
      }
    },
    {
      path: "edit-user",
      name: "Edit User",
      component: () =>
        import(
          "@/components/Pages/UserManagement/UsersComponents/editUser.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          1,
          2
        )
      }
    },
    {
      path: "view-user",
      name: "View User",
      component: () =>
        import(
          "@/components/Pages/UserManagement/UsersComponents/viewUser.vue"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          1,
          1
        )
      }
    },
    {
      path: "aggregators-users",
      name: "Aggregators",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/AggregatorsComponents/aggregators"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          2,
          1
        )
      }
    },
    {
      path: "add-aggregator",
      name: "Add Aggregator",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/AggregatorsComponents/addAggregator"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          2,
          2
        )
      }
    },
    {
      path: "edit-aggregator",
      name: "Edit Aggregator",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/AggregatorsComponents/editAggregator"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          2,
          2
        )
      }
    },
    {
      path: "view-aggregator",
      name: "View Aggregator",
      component: () =>
        import(
          "@/components/Pages/ExhibitorManagement/AggregatorsComponents/viewAggregator"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          2,
          1
        )
      }
    },

    {
      path: "roles",
      name: "Roles",
      component: () =>
        import("@/components/Pages/UserManagement/RolesComponents/roles"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          3,
          1
        )
      }
    },
    {
      path: "edit-role",
      name: "Edit Role",
      component: () =>
        import("@/components/Pages/UserManagement/RolesComponents/editRole"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          3,
          2
        )
      }
    },
    {
      path: "add-role",
      name: "Add Role",
      component: () =>
        import("@/components/Pages/UserManagement/RolesComponents/addRole"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          3,
          2
        )
      }
    },
    {
      path: "view-role",
      name: "View Role",
      component: () =>
        import("@/components/Pages/UserManagement/RolesComponents/viewRole"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          3,
          1
        )
      }
    },
    {
      path: "designations",
      name: "Designations",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DesignationsComponents/designations"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          4,
          1
        )
      }
    },
    {
      path: "add-designation",
      name: "Add Designation",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DesignationsComponents/addDesignation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          4,
          2
        )
      }
    },
    {
      path: "edit-designation",
      name: "Edit Designation",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DesignationsComponents/editDesignation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          4,
          2
        )
      }
    },
    {
      path: "view-designation",
      name: "View Designation",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DesignationsComponents/viewDesignation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          4,
          1
        )
      }
    },
    {
      path: "add-department",
      name: "Add Department",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DepartmentComponents/addDepartment"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          5,
          2
        )
      }
    },
    {
      path: "edit-department",
      name: "Edit Department",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DepartmentComponents/editDepartment"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          5,
          2
        )
      }
    },
    {
      path: "list-department",
      name: "List Department",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DepartmentComponents/listDepartment"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          5,
          1
        )
      }
    },
    {
      path: "view-department",
      name: "View Department",
      component: () =>
        import(
          "@/components/Pages/UserManagement/DepartmentComponents/viewDepartment"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          5,
          1
        )
      }
    },
    // GENDER
    {
      path: "genders",
      name: "Gender",
      component: () =>
        import("@/components/Pages/UserManagement/GenderComponents/gender"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          6,
          1
        )
      }
    },
    {
      path: "add-gender",
      name: "Add Gender",
      component: () =>
        import("@/components/Pages/UserManagement/GenderComponents/addGender"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          6,
          2
        )
      }
    },
    {
      path: "edit-gender",
      name: "Edit Gender",
      component: () =>
        import("@/components/Pages/UserManagement/GenderComponents/editGender"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          6,
          2
        )
      }
    },
    {
      path: "view-gender",
      name: "View Gender",
      component: () =>
        import("@/components/Pages/UserManagement/GenderComponents/viewGender"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          6,
          1
        )
      }
    },
    // MARITAL STATUS
    {
      path: "marital-status",
      name: "Marital status",
      component: () =>
        import(
          "@/components/Pages/UserManagement/MaritalStatusComponents/maritalStatus"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          7,
          1
        )
      }
    },
    {
      path: "add-marital-status",
      name: "Add Marital status",
      component: () =>
        import(
          "@/components/Pages/UserManagement/MaritalStatusComponents/addMaritalStatus"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          7,
          2
        )
      }
    },
    {
      path: "edit-marital-status",
      name: "Edit Marital status",
      component: () =>
        import(
          "@/components/Pages/UserManagement/MaritalStatusComponents/editMartialStatus"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          7,
          2
        )
      }
    },
    {
      path: "view-marital-status",
      name: "View Marital status",
      component: () =>
        import(
          "@/components/Pages/UserManagement/MaritalStatusComponents/viewMartialStatus"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          7,
          1
        )
      }
    },
    {
      path: "renunciation",
      name: "Renunciation",
      component: () =>
        import(
          "@/components/Pages/UserManagement/RenunciationComponents/renunciation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          8,
          1
        )
      }
    },
    {
      path: "add-renunciation",
      name: "Add Renunciation",
      component: () =>
        import(
          "@/components/Pages/UserManagement/RenunciationComponents/addrenunciation"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          8,
          2
        )
      }
    },
    {
      path: "user-audit-log",
      name: "User Audit Logs",
      component: () =>
        import("@/components/Pages/UserManagement/UserAuditLog/userAuditLog"),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          9,
          2
        )
      }
    },
    {
      path: "view-user-audit-log",
      name: "Single User Audit Logs",
      component: () =>
        import(
          "@/components/Pages/UserManagement/UserAuditLog/viewUserAuditLog"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          9,
          1
        )
      }
    },
    {
      path: "notifications-log",
      name: "Notification Logs",
      component: () =>
        import(
          "@/components/Pages/UserManagement/NotificationLogComponents/listnotificationlogs"
        ),
      meta: {
        permissions: getPermissions(
          ["SuperAdmin", "CinemaManager", "HoManager"],
          false,
          "",
          10,
          2
        )
      }
    },
    {
      path: "ejs-design-viewer",
      name: "Ejs Design Viewer",
      component: () =>
        import("@/components/Pages/UserManagement/ejsdesignview"),
      meta: {
        permissions: getPermissions(["SuperAdmin"], false, "", 10, 2)
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/router/userRoutes.js